module.exports = __webpack_public_path__ + "img/searching.4ad3978f.png";